export enum ReportSection {
  InstitutionDetails = 'InstitutionDetails',
  InstitutionInvestmentApproach = 'InstitutionInvestmentApproach',
  FinancialHighlights = 'FinancialHighlights',
  EquityPortfolio = 'EquityPortfolio',
  HistoricalOwnership = 'HistoricalOwnership',
  ActivityHistory = 'ActivityHistory',
  Notes = 'Notes',
  InstitutionBaseInfo = 'InstitutionBaseInfo',
  ContactBaseInfo = 'ContactBaseInfo',
  ContactBiography = 'ContactBiography',
  SustainabilityFocus = 'SustainabilityFocus',
  Targeting = 'Targeting',
  PeerOwnership = 'PeerOwnership',
  SuitabilityFactors = 'SuitabilityFactors',
  PrimaryContactBiography = 'PrimaryContactBiography',
  CustomFields = 'CustomFields',
  FundSummary = 'FundSummary',
  DrPriceVolume = 'DRPriceVolume',
  YtdPriceVolume = 'YTDPriceVolume',
  CrossBorderBrokerActivity = 'CrossBorderBrokerActivity',
  None = 'None',
  Disclosure = 'Disclosure',

  TradingAnalysisAll = 'TradingAnalysisAll',
  TradingAnalysisBuys = 'TradingAnalysisBuys',
  TradingAnalysisSells = 'TradingAnalysisSells',

  PredictedMovements = 'PredictedMovements',
  StyleName = 'StyleName',
  HolderRegionName = 'HolderRegionName',
  HolderInvestmentCenterName = 'HolderInvestmentCenterName',
  HolderCountryName = 'HolderCountryName',
  SustainabilityFitMetric = 'SustainabilityFitMetric',
  ParticipantBiography = 'ParticipantBiography',
  Orientation = 'Orientation',
  Turnover = 'Turnover',
  CombinedOwnership = 'CombinedOwnership',
  MonthlyDrActivity = 'MonthlyDrActivity',

  TradingActivity = 'TradingActivity',
  ActivityIndicators = 'ActivityIndicators',
  CrossBorderTrading = 'CrossBorderTrading',
  WeekPriceVolume = 'WeekPriceVolume',
  DRIssueAndCancelActivity = 'DRIssueAndCancelActivity',
  HighTradingVolumeBrokers = 'HighTradingVolumeBrokers',
  DepositaryReceiptsContact = 'DepositaryReceiptsContact',
  PriceActivity = 'PriceActivity',
  TopHolders = 'TopHolders',
  TopBuyersSellers = 'TopBuyersSellers',
  BnyHeader = 'BnyManagementReportHeaderInfo',
  ItineraryComments = 'ItineraryComments',
  ItineraryActivityHeader = 'ItineraryActivityHeader',
  ItineraryParticipantInfo = 'ItineraryParticipantInfo',
  ItineraryActivityAttributes = 'ItineraryActivityAttributes',
  ItineraryParticipantBio = 'ItineraryParticipantBio',
  ItineraryActivityHistory = 'ItineraryActivityHistory',
  ItineraryPeerOwnership = 'ItineraryPeerOwnership',

  TopShareHolders = 'TopShareHolders',

  AiSummaryCard = 'AiSummaryCard'
}
